import TerminalsInfoGroupTitle from '@components/pages/Products/components/RouteProduct/components/TerminalsInfo/components/TerminalsInfoGroupTitle';
import TerminalsInfoRowIncludedAllowance from '@components/pages/Products/components/RouteProduct/components/TerminalsInfo/components/TerminalsInfoRowIncludedAllowance';
import ShoulderItemDetailsDTO, {
  RowProps,
} from '@services/collectors/ProductService/ShoulderItemDetailsDTO';
import { Order } from '@services/requests/orderService/interface';
import { BranchItem } from '@services/requests/routeCalculator/locationsBranchSearchService/interfaces';
import { CurrencyData } from '@services/requests/searchLoaders/currencyLoader/CurrencyLoaderQuery';
import React, { FC } from 'react';

import OfferDetailTableHeaderData from '../../../ShoulderItemHeaderData';
import ShoulderItemTableBody from '../../../ShoulderItemTable/components/ShoulderItemTableBody';

interface Props {
  id: string;
  branchItem: BranchItem;
  firstTerminal: boolean;
  lastTerminal: boolean;
  isIncluded: boolean;
  order: Order;
  crossDockingRowsData: RowProps[];
  currencyRoute: CurrencyData;
}

/**
 * Компонент выводит данные при отсутствии надбавок
 */
const TerminalsInfoWithFullIncludedAllowance: FC<Props> = ({
  id,
  branchItem,
  firstTerminal,
  lastTerminal,
  isIncluded,
  order,
  crossDockingRowsData,
  currencyRoute,
}) => {
  let type = 'loading/unloading';
  let included = true;
  if (firstTerminal) {
    type = 'load';
    included = isIncluded;
  }
  if (lastTerminal) {
    type = 'unload';
    included = isIncluded;
  }

  const column = OfferDetailTableHeaderData(currencyRoute, order);
  const rowsData = [...ShoulderItemDetailsDTO([...crossDockingRowsData])];

  return (
    <div>
      <TerminalsInfoGroupTitle id={id} branchItem={branchItem} order={order} />
      <TerminalsInfoRowIncludedAllowance
        type={type}
        isIncluded={included}
        order={order}
        borderBottom={rowsData.length > 0}
      />
      {rowsData.length > 0 && <ShoulderItemTableBody rows={rowsData} columns={column} />}
    </div>
  );
};

export default TerminalsInfoWithFullIncludedAllowance;
